import get from "lodash/get";
import ProductHero from "./ProductHero";
import formatPrismicData from "../../hocs/formatPrismicData";
import withProduct from "../../hocs/withProduct";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";
import scrollTo from "../../utils/scrollTo";
import withMedia from "../../hocs/withMediaQueries";
import withCountry from "../../hocs/withCountry";
import { withModel } from "../../data-providers/model";

const enhance = compose(
  formatPrismicData,
  withCountry,
  withProduct,
  withState("isCarouselMediaPlaying", "setIsCarouselMediaPlaying", false),
  withMedia,
  withModel,
  withProps((props) => {
    const otherSkusForTrustPilotReviews = get(
      props,
      "model.prismicProduct.main.matchingSkusForTrustpilot",
      []
    );

    const newProps = {
      isNavigationDisabled: !!(
        props.isCarouselMediaPlaying || props.media.tabletUp
      ),
      includeSchema: !props.model.prismicPageModel.hasTrustPilot,
      trustPilotSkus: [props.productId]
        .concat(otherSkusForTrustPilotReviews)
        .join(","),
    };
    if (props.product) {
      newProps.price = props.product.lowestPrice;
    }
    return newProps;
  }),
  withHandlers({
    handleReviewCtaClick: (props) => (e) => {
      e.preventDefault();
      scrollTo(props.productReviewHref);
    },
  })
);

export default enhance(ProductHero);
